<!-- 通知公告 -->
<template>
    <div class="main-area">
        <el-breadcrumb separator=":">
            <el-breadcrumb-item>当前位置</el-breadcrumb-item>
            <el-breadcrumb-item>通知公告栏目配置</el-breadcrumb-item>
        </el-breadcrumb>

        <el-row class="margin-top-10">
            <el-col :span="2" class="margin-top-10">
                <label class="search-label">
                栏目名称:
                </label>
            </el-col>
            <el-col :span="4" class="margin-top-10">
                <el-input v-model="searchForm.title"
                        :size="GLOBAL.config.systemSize"
                        placeholder="栏目名称"
                        clearable
                        maxlength="32"></el-input>
            </el-col>
            <!-- <el-col :span="2" class="margin-top-10">
                <label class="search-label">
                是否签收:
                </label>
            </el-col>
            <el-col :span="4" class="margin-top-10">
                <el-select v-model="searchForm.sfqs" clearable placeholder="请选择" :size="GLOBAL.config.systemSize" style="width:100%;">
                    <el-option
                    v-for="item in sfqsOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="2" class="margin-top-10">
                <label class="search-label">
                是否已读:
                </label>
            </el-col>
            <el-col :span="4" class="margin-top-10">
                <el-select v-model="searchForm.sfyd" clearable placeholder="请选择" :size="GLOBAL.config.systemSize" style="width:100%;">
                    <el-option
                    v-for="item in sfydOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </el-col> -->
            <el-col :span="2" class="margin-top-10">
                <el-button type="primary" @click="doSearch" :size="GLOBAL.config.systemSize" icon="el-icon-search">查询
                </el-button>
            </el-col>
        </el-row>

        <el-row class="margin-top-20">
            <el-col :span="24">
                <el-button v-if="source.add && tableData.length < 4 && lmLength != '4'"
                        type="primary"
                        icon="el-icon-plus"
                        :size="GLOBAL.config.systemSize"
                        style="float: left;"
                        @click="operationMethod('add')">新增
                </el-button>
                <!-- <el-button v-if="source.deleteBatch"
                        type="danger"
                        icon="el-icon-delete"
                        :size="GLOBAL.config.systemSize"
                        style="float: left;"
                        :disabled="deleteBatchList.ids.length === 0"
                        @click="deleteBatch">批量删除
                </el-button> -->
            </el-col>
        </el-row>

        <el-table style="width: 100%"
            :data="tableData"
            @selection-change="tableSelectionChange"
            element-loading-text="数据处理中...请稍等..."
            v-loading="loading">
            <!-- <el-table-column
                type="selection">
            </el-table-column> -->
            <!--序号-->
            <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
            <el-table-column label="栏目名称" prop="title" align="center"></el-table-column>
<!--            <el-table-column label="所属区划" prop="ssqhdmName" align="center"></el-table-column>-->
            <!-- <el-table-column label="是否签收" prop="sfqs" align="center">
                <template slot-scope="scope" >
                    <span>{{scope.row.sfqs == '0' ? '签收' : '无需签收'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="是否已读" prop="sfyd" align="center">
                <template slot-scope="scope" >
                    <span>{{scope.row.sfyd == '0' ? '已读' : '未读'}}</span>
                </template>
            </el-table-column> -->
            <el-table-column label="内容" prop="nr" align="center"></el-table-column>
            <el-table-column prop="cjsj" label="创建时间" align="center" :formatter="formatterTime"/>
            <el-table-column prop="scope" label="操作" align="center">
                <template slot-scope="scope">
                    <el-dropdown>
                            <span class="el-dropdown-link operator-text">
                            选择操作<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                        <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :icon="item.icon" v-for="item in getSource(scope.row)"
                                            :key="item.method"
                                            @click.native="handleCommon(item.method, scope.row)">
                            {{item.title}}
                        </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>

<!--        <el-pagination-->
<!--            class="margin-top-10 margin-bottom-20"-->
<!--            @size-change="tableSizeChange"-->
<!--            @current-change="currentChange"-->
<!--            :current-page="pagination.currentPage"-->
<!--            :page-sizes="pagination.pageSizeList"-->
<!--            :page-size="pagination.pageSize"-->
<!--            :layout="pagination.layout"-->
<!--            :total="pagination.total">-->
<!--        </el-pagination>-->

        <NoticeEditDialog ref="noticeEditDialog" :refresh="init" :close-self="()=> viewVisibleFlag = false" />
    </div>
</template>

<script>

import NoticeEditDialog from './NoticeEditDialog'
export default {
    name: 'NoticeTable',

    components: {
        NoticeEditDialog
    },

    data() {
        return {
            lmLength: '',
            source: {
                add: true,
                deleteBatch: true,
                export: true,
                import: true,
                infoView: true,
                infoEdit: true,
                infoDelete: true,
                exportTemplate: true
            },
            searchForm: {
                nr: '',
                sfqs:'',
                sfyd: '',
                title: ''
            },
            sfqsOptions: [
                {value: '0', label: '签收'},
                {value: '1', label: '无需签收'}
            ],
            sfydOptions: [
                {value: '0', label: '已读'},
                {value: '1', label: '未读'}
            ],
            deleteBatchList: {
                ids: [],
                deleteFlag: false
            },
            tableData: [],
            loading: false,
            // 分页参数
            pagination: {
                pageSizeList: [10, 20, 30, 40, 50],
                pageSize: 10,
                layout: 'total, sizes, prev, pager, next, jumper',
                total: 0,
                currentPage: 1
            },
        }
    },

    methods: {
        doSearch: function () {
            this.getTableData('init')
        },
        init: function () {
            this.getTableData('init')
        },
        // 新增
        operationMethod(addInfo, info) {
            this.$refs.noticeEditDialog.open(addInfo, info)
        },
        // 复选框选择事件
        tableSelectionChange: function (targetList) {
            let ids = []
            targetList.forEach(item => {
                ids.push(item.uuid)
            })
            this.deleteBatchList.ids = ids
            if (this.deleteBatchList.ids &&
                this.deleteBatchList.ids.length > 0) {
                this.deleteBatchList.deleteFlag = true
            } else {
                this.deleteBatchList.deleteFlag = false
            }
        },
        formatterTime(row, column, data) {
            if (!data) {
                return "";
            }
            var reg = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
            return data.replace(reg, "$1-$2-$3 $4:$5:$6");
        },
         // 获取操作展示
        getSource: function (rowData) {
            let tempList = []
            // this.source.infoView && tempList.push({icon: 'el-icon-view', title: '查看', method: 'handleView'})
            this.source.infoEdit && tempList.push({icon: 'el-icon-edit', title: '编辑', method: 'handleEdit'})
            this.source.infoDelete && tempList.push({icon: 'el-icon-delete', title: '删除', method: 'handleDelete'})
            return tempList
        },
        handleCommon: function (type, rowData) {
            switch (type) {
                case 'handleView':
                    this.handleView(rowData)
                    break
                case 'handleEdit':
                    this.handleEdit(rowData)
                    break
                case 'handleDelete':
                    this.handleDelete(rowData)
                    break
            }
        },
        handleView(rowData) {

        },
        handleEdit(rowData) {
            this.$refs.noticeEditDialog.open('edit', rowData)
        },
        handleDelete(rowData) {
            let _this = this
            let param = {
                info: rowData.uuid,
                baseService: 'TGcTztgServiceImpl',
                // baseService: _this.GLOBAL.config.baseServiceType.TGcGcdaServiceImpl,
                type: _this.GLOBAL.config.handleType.deleteLogical
            }
            _this.$confirm('确认删除当前数据？？', '提示', {
            }).then(() => {
                _this.FUNCTIONS.systemFunction.jsonPost(
                    _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                    param,
                    resultData => {
                        _this.loading = false
                        if (resultData) {
                            _this.$message.success('删除成功～')
                            _this.getTableData('init')
                        } else {
                            _this.$message.warning('删除失败～')
                        }
                    }
                )
            })
        },
        deleteBatch() {

        },
        // 分页方法
        tableSizeChange: function (pageSize) {
            this.pagination.pageSize = pageSize
            this.getTableData()
        },

        currentChange: function (current) {
            this.pagination.currentPage = current
            this.getTableData();
        },

        getTableData(initPageFlag) {
            this.loading = true
            let _this = this;
            // 3、 调接口获取数据
            let searchParams = _this.searchForm;
            _this.FUNCTIONS.systemFunction.removeNullFields(searchParams)
            let paginationData = _this.FUNCTIONS.systemFunction.paginationSet(
                    initPageFlag ? 1 : _this.pagination.currentPage,
                    initPageFlag ? 10 : _this.pagination.pageSize,
                    searchParams)
            paginationData.baseService = "TGcTztgServiceImpl",
            _this.FUNCTIONS.systemFunction.interactiveData(
                _this,
                _this.GLOBAL.config.businessFlag.zxUser,
                _this.GLOBAL.config.handleType.getPage,
                paginationData,
                null,
                resultData => {
                    _this.loading = false
                    if (resultData) {
                        // 结果参数赋值
                        _this.tableData = resultData.obj.records;
                        _this.pagination.pageSize = resultData.obj.size
                        _this.pagination.total = resultData.obj.total
                        _this.pagination.currentPage = resultData.obj.current
                        if (!_this.searchForm.title) {
                            _this.lmLength = _this.pagination.total
                        }
                    } else {
                        _this.$message.warning('获取列表数据失败～')
                    }
                },
                () => {
                    _this.loading = false
                }
            )
        },
    },
    mounted() {
        this.getTableData('init');
    }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/notice/NoticeTable.vue